import DpitBB from './DpitBB';
import { getAdminBarHeight } from './../../../../../includes/assets/js/modules/dpitUtilsInc';
import { hideElement, showElement } from '../../../../../includes/assets/js/modules/dpitHidden';


export const IDS = {
	target: 'dpit-vis-target',
	flier: 'dpit-vis-flier',
	docBoard: 'dpit-vis-doc-board',
	screenBoard: 'dpit-vis-screen-board',
	screen: 'dpit-vis-screen',
	doc: 'dpit-vis-doc'
};

const ACTIVE_VISUALIZERS = {
	[IDS.target]: false,
	[IDS.flier]: true,
	[IDS.docBoard]: false,
	[IDS.screenBoard]: true,
	[IDS.screen]: false,
	[IDS.doc]: false,
};


const CONFIG = {
	[IDS.target]: { color: 'rgba(0, 0, 255, 0.3)' },
	[IDS.flier]: { color: 'rgba(0, 255, 255, 0.3)' },
	[IDS.docBoard]: { color: 'rgba(255,0,0,0.3)' },
	[IDS.doc]: { color: 'rgba(255,100,0,0.2)' },
	[IDS.screenBoard]: { color: 'rgba(255,0,255,0.3)' },
	[IDS.screen]: { color: 'rgba(255,100,255,0.2)' }

};


export default class DpitDebugVisualizer {
	constructor(container) {
		this.container = container;
		this.visualizerElements = {};
	}

	visualizeBB(id, bb, fixed, adjustHeightByAdminBar = false) {
		if (bb) {
			if (!this.visualizerElements[id]) {
				this.visualizerElements[id] = document.createElement('div');
				this.visualizerElements[id].id = id;
				this.container.append(this.visualizerElements[id]);
			}

			const color = CONFIG[id].color;

			let adminBarHeight = getAdminBarHeight();
			if (isNaN(adminBarHeight)) adminBarHeight = 0;
			const boardToVisualize = DpitBB.supplyWidthHeight(bb);

			Object.assign(this.visualizerElements[id].style, {
				position: fixed ? 'fixed' : 'absolute',
				backgroundColor: color,
				top: (boardToVisualize.top) - (adjustHeightByAdminBar ? adminBarHeight : 0) + 'px',
				left: boardToVisualize.left + 'px',
				width: boardToVisualize.width + 'px',
				height: (boardToVisualize.height) + 'px', //(adjustHeightByAdminBar ? adminBarHeight : 0)
				pointerEvents: 'none',
				zIndex: 'calc(var(--dp-z-index-base) + 5)',
			});
			showElement(this.visualizerElements[id]);
		}
	}

	clearStepVisualizers() {
		hideElement(this.visualizerElements[IDS.target], false);
		hideElement(this.visualizerElements[IDS.flier], false);
	}

	clearVisualizers() {
		Object.keys(this.visualizerElements).forEach(id => {
			hideElement(this.visualizerElements[id], false);
		});
	}

	destroy() {
		Object.keys(this.visualizerElements).forEach(id => {
			this.visualizerElements[id].remove();
		});
	}

	visualizeBoards(docBoardBB, winBoardBB, docBB, winBB) {

		if (ACTIVE_VISUALIZERS[IDS.doc]) this.visualizeBB(IDS.doc, docBB, false);
		if (ACTIVE_VISUALIZERS[IDS.docBoard]) this.visualizeBB(IDS.docBoard, docBoardBB, false);
		if (ACTIVE_VISUALIZERS[IDS.screen]) this.visualizeBB(IDS.screen, winBB, true, false);
		if (ACTIVE_VISUALIZERS[IDS.screenBoard]) this.visualizeBB(IDS.screenBoard, winBoardBB, true, false);

	}

	visualizeStepData(targetBB, flierBB, isFixedPos) {
		if (ACTIVE_VISUALIZERS[IDS.flier]) this.visualizeBB(IDS.flier, flierBB, isFixedPos, false);
		if (ACTIVE_VISUALIZERS[IDS.target]) this.visualizeBB(IDS.target, targetBB, isFixedPos, false);
	}
}





